import { useState } from 'react';
import { Button } from '@heroui/react';

import Notice from './Notice';
import apiClient from '../../services/apiClient';
import { messageOf, EXPORT } from '../../i18n/el';

// ΛΑ-28: το σημείο εισόδου της σημασιολογικής εξαγωγής στη διεπαφή.
//
// Η λειτουργία υπήρχε και ελεγχόταν από το P2-2, και **καμία οθόνη δεν οδηγούσε σε
// αυτήν**: έφτανε μόνο από τερματικό ή από το πρόσθετο WordPress. Λειτουργία που
// υπάρχει στο API και δεν φτάνει στον χρήστη δεν καλύπτει απαίτηση — είναι η
// κατηγορία Α του Κεφαλαίου 6, και ο κανόνας 2 του πίνακα κάλυψης την απαγορεύει.
//
// **Ένα συστατικό για τις δύο θέσεις** — τη συλλογή και τον πόρο — γιατί η ενέργεια
// είναι η ίδια και μόνο η διαδρομή αλλάζει. Δύο αντίγραφα θα ήταν δύο διατυπώσεις
// του ίδιου μηνύματος σφάλματος και της ίδιας κατάστασης αναμονής.
//
// **Λήψη και όχι αντιγραφή στο πρόχειρο.** Το επιχείρημα ζει στην `apiClient`, δίπλα
// στον κώδικα που το εκτελεί: ο εξυπηρετητής δηλώνει ήδη αρχείο με όνομα, και ο
// σύνδεσμος που θα κατέβαζε χωρίς αίτημα θα απαιτούσε το διακριτικό μέσα στη
// διεύθυνση.

/**
 * @param path Η διαδρομή εξαγωγής. Ο καλών την ξέρει· το συστατικό δεν την
 *   κατασκευάζει, ώστε να μη γνωρίζει τη μορφή δύο διαφορετικών πόρων.
 * @param fallbackName Όνομα αρχείου **μόνο** αν ο εξυπηρετητής δεν δηλώσει δικό
 *   του. Δεν είναι το κανονικό όνομα και δεν το αντιγράφει.
 */
export default function ExportJsonLd({ path, fallbackName = 'export.jsonld', size = 'md', className = '' }) {
    const [isBusy, setBusy] = useState(false);
    const [error, setError] = useState('');

    function run() {
        setError('');
        setBusy(true);
        apiClient.download(path, fallbackName).then(
            () => setBusy(false),
            (apiError) => {
                setBusy(false);
                setError(messageOf(apiError));
            }
        );
    }

    return (
        <div className={`flex flex-col gap-2 ${className}`}>
            <Button variant="outline" size={size} onPress={run} isPending={isBusy}>
                <i className="fa-solid fa-file-export" aria-hidden="true" />
                {EXPORT.action}
            </Button>

            {/* Το σφάλμα **δίπλα στην ενέργεια** και ποτέ στην κορυφή της σελίδας: και
                οι δύο θέσεις του κουμπιού ζουν μέσα σε περιοχή με **δική της κύλιση**
                — η πλαϊνή στήλη της συλλογής και το υποσέλιδο του παραθύρου — οπότε
                μήνυμα σε άλλο σημείο μπορεί να βρεθεί εκτός οπτικού πεδίου τη στιγμή
                που ο χρήστης περιμένει απάντηση. */}
            {error && (
                <Notice status="danger" title={EXPORT.failed} onDismiss={() => setError('')}>
                    {error}
                </Notice>
            )}
        </div>
    );
}
